<template>
  <NuxtLayout
    :id="PLAY_SLIP_EDITOR_ID"
    aria-roledescription="carousel"
    header-height="7.5rem"
    name="sticky"
    role="region"
    shamrock
  >
    <template #header>
      <LotteryHeader
        class="header"
        left-button-icon="arrow-left"
        with-fly-out
        @click="navigateToBackroute"
      >
        <LotteryPagination />
      </LotteryHeader>
    </template>

    <slot />

    <TheMetaLinks class="the-meta-links" />

    <template #navbar>
      <LotteryPlaySlipNavbar>
        <template v-if="$slots['navbar-incomplete-modal-headline']" #headline="slotProps">
          <slot name="navbar-incomplete-modal-headline" v-bind="slotProps" />
        </template>
        <template v-if="$slots['navbar-incomplete-modal-cancel']" #cancel>
          <slot name="navbar-incomplete-modal-cancel" />
        </template>
        <template v-if="$slots['navbar-incomplete-modal-confirm']" #confirm>
          <slot name="navbar-incomplete-modal-confirm" />
        </template>
        <template v-if="$slots['navbar-incomplete-modal-message']" #message>
          <slot name="navbar-incomplete-modal-message" />
        </template>
      </LotteryPlaySlipNavbar>
    </template>
  </NuxtLayout>
</template>

<script lang="ts" setup>
import { PLAY_SLIP_EDITOR_ID } from '../constants/playSlip'

const { navigateToBackroute } = useRouterUtils()
</script>
